var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { IndicatorValueLabel } from './indicator-value-label';
var cls = classNames('indicator-result-label');
export var IndicatorLabelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n  "])))
});
var FormattedValueStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var UnitStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 300;\n  "], ["\n    font-weight: 300;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorLabel',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  FormattedValue: styled(IndicatorValueLabel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), FormattedValueStyles),
  Unit: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), UnitStyles)
};
export var IndicatorLabel = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorLabelDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity;
  var unit = entity.unit;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.FormattedValue, {
    entity: entity
  }), React.createElement(My.Unit, null, (unit === null || unit === void 0 ? void 0 : unit.shorthand) || (unit === null || unit === void 0 ? void 0 : unit.name)));
};
IndicatorLabel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;